import { render, staticRenderFns } from "./ssoLeverantorsreskontraWidget.vue?vue&type=template&id=17174236&"
import script from "./ssoLeverantorsreskontraWidget.vue?vue&type=script&lang=js&"
export * from "./ssoLeverantorsreskontraWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\TeamCity\\Edison.Sso\\Dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17174236')) {
      api.createRecord('17174236', component.options)
    } else {
      api.reload('17174236', component.options)
    }
    module.hot.accept("./ssoLeverantorsreskontraWidget.vue?vue&type=template&id=17174236&", function () {
      api.rerender('17174236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "v-components/widgets/ssoLeverantorsreskontraWidget.vue"
export default component.exports